import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

/**
 * Interceptor que agrega las credenciales de autenticación a las peticiones HTTP
 * @description Clona la petición HTTP y añade el parámetro withCredentials con el valor true
 * @param {HttpRequest<unknown>} req - Petición HTTP original
 * @param {HttpHandlerFn} next - Función para continuar con la petición
 * @returns {Observable<HttpEvent<unknown>>} Observable con la respuesta HTTP
 */
export function WithCredentialsInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {
  return next(req.clone({ withCredentials: true }));
}
